import { combineReducers } from 'redux';
import uiAddressReducers from './ui/address';
import uiPHPAddressReducers from './ui/address-php';
import uiConfirmReducers from './ui/confirm';
import storeInformationReducer from './store/information';
import categoryAppReducers from './ui/category-app';
import categoryProductReducers from './ui/category-product';
import viewsAndUploadReducers from './imgs/viewsAndUpload';
import actionSheetReducers from './ui/actionsheet';
import expertEditReducers from './pages/expert-edit';
import formulaReducers from './pages/formula';
import productEditReducers from './pages/product-edit';

export default combineReducers({
    uiAddressReducers,
    uiPHPAddressReducers,
    uiConfirmReducers,
    viewsAndUploadReducers,
    actionSheetReducers,
    categoryAppReducers,
    categoryProductReducers,
    expertEditReducers,
    formulaReducers,
    storeInformationReducer,
    productEditReducers
});